import { render, staticRenderFns } from "./AddRegion.vue?vue&type=template&id=0b512ff0&scoped=true&"
import script from "./AddRegion.vue?vue&type=script&lang=js&"
export * from "./AddRegion.vue?vue&type=script&lang=js&"
import style0 from "./AddRegion.vue?vue&type=style&index=0&id=0b512ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b512ff0",
  null
  
)

export default component.exports